var lists_default = {
  "fontElementMap": "cibsj",
  "orderedlist": "SPW3O",
  "bulletedlist": "jnuVW",
  "listItem": "AOXBN"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
